<div class="tw-font-bold tw-text-xl md:tw-text-3xl tw-text-center tw-text-white tw-capitalize tw-px-4">Become our
    partner in 3
    simple steps
</div>
<p class="tw-text-center tw-text-sm md:tw-text-base tw-p-10 tw-text-white">Unlike a traditional car lease company, our
    onboarding
    journey is simple, digital & transparent</p>

<div class="container tw-flex tw-flex-col md:tw-flex-row tw-gap-3 md:tw-gap-8">
    <div class="tw-flex tw-flex-col md:tw-flex-row tw-gap-2 tw-items-center"
        *ngFor="let onboard of onboardingKeys; let i = index">
        <div class="tw-flex tw-items-center tw-w-full">
            <div class="tw-min-w-[6rem] md:tw-min-w-[7rem] tw-min-h-[6rem] md:tw-min-h-[7rem] 
            tw-w-[6rem] md:tw-w-[7rem] tw-h-[6rem] md:tw-h-[7rem]">
                <img src="/assets/images/corporate/{{onboard.icon}}" alt="{{onboard.label}}">
            </div>
            <div class="tw-text-sm tw-font-bold tw-text-white tw-px-2">
                {{onboard.label}}
            </div>
        </div>
        <div *ngIf="i !== onboardingKeys.length-1" class="tw-rotate-90 md:tw-rotate-0 tw-mr-auto tw-ml-10 tw-mt-2 md:tw-ml-0 ">
            <fa-icon [icon]="faAngleRight" class="tw-text-3xl tw-text-white"></fa-icon>
        </div>
    </div>
</div>
<div class="tw-text-center tw-mt-6 md:tw-mt-12">
    <a type="button" href="contact-us"
        class="tw-rounded-md tw-bg-pinkDark tw-px-4 tw-py-2 tw-text-white tw-text-xs md:tw-text-sm tw-font-bold hover:tw-text-white">
        Get in touch &nbsp;<fa-icon [icon]="faArrowRight"></fa-icon>
    </a>
</div>